
if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      get quantity() {
        return this.querySelector('quantity-input');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get select() {
        return this.querySelector('select');
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          `.main-product-form[data-product-id="${this.productId}"]`
        );
        this.mainProductInfo = document.querySelector(
          `product-info[data-product-id="${this.productId}"]`
        );
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect
        ).value;

        const img = this.querySelector(
          '.sticky-atc-bar__product-image img'
        );
        this.mainImageSrc = img ? img.src : null;
        this.mainImageAlt = img ? img.alt : '';

        this.variantData = this.getVariantData();

        // CODICE CUSTOM EB COSMETICA
        // Inizializzazione della variante selezionata.
        this.currentVariant = this.variantData.find(
          (variant) =>
            variant.id === Number(this.selectedVariantId)
        );

        this.vatPriceObserver = null;
        this.quantityRequestId = 0;
        // FINE CODICE CUSTOM

        this.init();

        // CODICE CUSTOM EB COSMETICA
        // Sincronizza il prezzo IVA iniziale.
        this.updateVatPrice();
        // FINE CODICE CUSTOM

        this.select.addEventListener('change', (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          // codice originale
          // this.updateQuantityInput();
          // fine codice originale

          this.mainVariantSelects =
            this.mainProductInfo &&
            this.mainProductInfo.querySelector('variant-selects');

          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect
          ).value;

          this.currentVariant = this.variantData.find(
            (variant) =>
              variant.id === Number(selectedVariantId)
          );

          // CODICE CUSTOM EB COSMETICA
          // Memorizza il nuovo ID e aggiorna le quantità
          // soltanto dopo aver individuato la variante.
          this.selectedVariantId = selectedVariantId;

          if (!this.currentVariant) {
            this.updateButton(true, '', true);
            this.isUpdating = false;
            return;
          }

          this.updateQuantityInput();
          // FINE CODICE CUSTOM

          if (this.mainVariantSelects) {
            Array.from(
              this.mainVariantSelects.querySelectorAll(
                'select, fieldset'
              ),
              (element, index) => {
                const variantOptionVal =
                  this.currentVariant.options[index];

                switch (element.tagName) {
                  case 'SELECT':
                    element.value = variantOptionVal;

                    const options =
                      element.querySelectorAll('option');

                    options.forEach((option) =>
                      option.removeAttribute('selected')
                    );

                    element.value = variantOptionVal;

                    const selectedOption =
                      element.querySelector(
                        `option[value="${variantOptionVal}"]`
                      );

                    if (selectedOption) {
                      selectedOption.setAttribute(
                        'selected',
                        'selected'
                      );
                    }
                    break;

                  case 'FIELDSET':
                    Array.from(
                      element.querySelectorAll('input')
                    ).forEach((radio) => {
                      if (radio.value === variantOptionVal) {
                        radio.checked = true;
                      }
                    });
                    break;
                }
              }
            );

            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(
                new Event('change', {
                  detail: { formStickty: true }
                })
              );
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateImage();
          this.updateButton(true, '', false);

          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              FoxTheme.variantStrings.soldOut
            );
          }
        });

        const hasRequiredFields =
          this.validateMainProductRequiredFields();

        if (hasRequiredFields) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.productFormActions.scrollIntoView({
              behavior: FoxTheme.config.disableAnimations
                ? 'auto'
                : 'smooth',
              block: 'center'
            });

            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;

        const requiredFields =
          mainForm.querySelectorAll('[data-custom-property]');

        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        // codice originale
        // this.currentVariant = this.variantData.find(
        //   (variant) =>
        //     variant.id === Number(this.selectedVariantId)
        // );
        // fine codice originale

        // CODICE CUSTOM EB COSMETICA
        // Recupera sempre la variante attualmente selezionata.
        const selectedVariantId =
          this.querySelector('[name="id"]')?.value;

        const variant = this.variantData.find(
          (item) =>
            item.id === Number(selectedVariantId)
        );

        if (!variant) return;

        const requestId = ++this.quantityRequestId;
        // FINE CODICE CUSTOM

        // codice originale
        // fetch(
        //   `${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`
        // )
        // fine codice originale

        // CODICE CUSTOM EB COSMETICA
        fetch(
          `${this.getAttribute('data-url')}?variant=${variant.id}&section_id=${this.sectionId}`
        )
        // FINE CODICE CUSTOM
          .then((response) => {
            // CODICE CUSTOM EB COSMETICA
            if (!response.ok) {
              throw new Error(
                `HTTP ${response.status}`
              );
            }
            // FINE CODICE CUSTOM

            return response.text();
          })
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );

            const newQuantity = parsedHTML.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );

            // codice originale
            // if (newQuantity) {
            //   quantity.innerHTML = newQuantity.innerHTML;
            // }
            // fine codice originale

            // CODICE CUSTOM EB COSMETICA
            // Evita che una risposta precedente sovrascriva
            // la quantità della variante più recente.
            const currentId =
              this.querySelector('[name="id"]')?.value;

            if (
              quantity &&
              newQuantity &&
              requestId === this.quantityRequestId &&
              currentId === String(variant.id)
            ) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
            // FINE CODICE CUSTOM
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector(
              '[type="application/json"]'
            ).textContent
          );

        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add(
            'sticky-atc-bar--show'
          );
          return;
        }

        const mql = window.matchMedia(
          FoxTheme.config.mediaQueryMobile
        );

        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method =
                entry.intersectionRatio !== 1
                  ? 'add'
                  : 'remove';

              this.container.classList[method](
                'sticky-atc-bar--show'
              );
            });
          },
          { threshold: 1, rootMargin }
        );

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty(
          '--sticky-atc-bar-height',
          this.clientHeight + 'px'
        );
      }

      updateButton(
        disable = true,
        text,
        modifyClass = true
      ) {
        const productForm = this.querySelector(
          '#product-form-sticky-atc-bar'
        );

        if (!productForm) return;

        const addButton =
          productForm.querySelector('[name="add"]');

        if (!addButton) return;

        const addButtonText =
          addButton.querySelector('span');

        if (disable) {
          addButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute('disabled');

          addButtonText.textContent =
            FoxTheme.variantStrings.addToCart;
        }
      }

      updateImage() {
        const imageWrapper = this.querySelector(
          '[data-variant-image]'
        );

        if (!imageWrapper) return;

        const selected = this.querySelector(
          '[name="id"] option:checked'
        );

        const src = selected
          ? selected.getAttribute('data-variant-image')
          : null;

        let img = imageWrapper.querySelector('img');

        if (src) {
          if (img) {
            img.src = src;
            img.removeAttribute('srcset');
          } else {
            imageWrapper.innerHTML =
              `<img src="${src}" class="motion-reduce" loading="lazy" fetchpriority="low" is="image-lazy" widths="90, 180" sizes="90px">`;
          }
        } else if (this.mainImageSrc) {
          if (img) {
            img.src = this.mainImageSrc;
            img.removeAttribute('srcset');
          } else {
            imageWrapper.innerHTML =
              `<img src="${this.mainImageSrc}" class="motion-reduce" loading="lazy" fetchpriority="low" is="image-lazy" widths="90, 180" sizes="90px">`;
          }
        }
      }

      // codice originale
      // updatePrice() {
      //   FoxTheme.updatePriceFromVariant(
      //     this,
      //     this.currentVariant
      //   );
      // }
      // fine codice originale

      // CODICE CUSTOM EB COSMETICA
      // Aggiornamento sincronizzato prezzi IVA esclusa/inclusa.

      updatePrice() {
        // Mantiene l'aggiornamento nativo Sleek.
        FoxTheme.updatePriceFromVariant(
          this,
          this.currentVariant
        );

        // Aggiorna il prezzo IVA inclusa.
        this.updateVatPrice();

        // Controlla eventuali modifiche HTML effettuate
        // dal sistema prezzi originale del tema.
        if (!this.vatPriceObserver) {
          this.vatPriceObserver = new MutationObserver(
            () => {
              this.updateVatPrice();
            }
          );

          this.vatPriceObserver.observe(this, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      }

      updateVatPrice() {
        const variant = this.currentVariant;

        if (
          !variant ||
          typeof variant.price !== 'number'
        ) {
          return;
        }

        const priceElement = this.querySelector(
          '.price-incl-vat strong'
        );

        if (!priceElement) return;

        // Aliquota IVA fissa al 22%.
        const vatRate = 22;

        // I prezzi Shopify sono espressi in centesimi.
        const priceWithVat = Math.round(
          variant.price * (1 + vatRate / 100)
        );

        // Valuta attiva del negozio.
        const currency =
          window.Shopify?.currency?.active || 'EUR';

        const formattedPrice = new Intl.NumberFormat(
          'it-IT',
          {
            style: 'currency',
            currency: currency
          }
        ).format(priceWithVat / 100);

        // Evita modifiche ripetute al DOM e cicli
        // inutili del MutationObserver.
        if (
          priceElement.textContent !== formattedPrice
        ) {
          priceElement.textContent = formattedPrice;
        }
      }

      // FINE CODICE CUSTOM

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            // codice originale
            // const isMainProduct =
            //   event.data.sectionId ===
            //   this.mainProductInfo.dataset.section;
            // fine codice originale

            // CODICE CUSTOM EB COSMETICA
            if (!this.mainProductInfo) return;

            const isMainProduct =
              event.data.sectionId ===
              this.mainProductInfo.dataset.section;
            // FINE CODICE CUSTOM

            if (!isMainProduct) return;

            const variant = event.data.variant;
            const variantInput =
              this.querySelector('[name="id"]');

            // codice originale
            // this.currentVariant = variant;
            // variantInput.value = variant.id;
            // fine codice originale

            // CODICE CUSTOM EB COSMETICA
            // Sincronizzazione sicura della variante.
            this.currentVariant = variant;

            if (!variant || !variantInput) {
              this.updateButton(true, '', true);
              return;
            }

            this.selectedVariantId =
              String(variant.id);

            variantInput.value =
              String(variant.id);
            // FINE CODICE CUSTOM

            this.updateImage();
            this.updatePrice();
            this.updateButton(true, '', false);

            if (!variant) {
              this.updateButton(true, '', true);
            } else {
              this.updateButton(
                !variant.available,
                FoxTheme.variantStrings.soldOut
              );
            }

            this.updateQuantityInput();
          }
        );
      }

      // CODICE CUSTOM EB COSMETICA
      // Pulizia degli osservatori quando il componente
      // viene rimosso dalla pagina.
      disconnectedCallback() {
        if (this.vatPriceObserver) {
          this.vatPriceObserver.disconnect();
          this.vatPriceObserver = null;
        }

        if (this.observer) {
          this.observer.disconnect();
        }
      }
      // FINE CODICE CUSTOM
    }
  );
}
